import Footer from '@/components/Footer'
import HomeSwap from './components/Swap'
import HomeTips from './components/Tips'
import HomeTrade from './components/Trade'
import HomeHelp from './components/Help'
import HomeAdd from './components/Add'

import TOP_BG from '@/assets/home/home-top-bg.png'
import { ReactComponent as BG_BLACK } from '@/assets/help/help-top-bg-black.svg'
import TIPS_BG from '@/assets/home/home-tips.png'

export default function HomeTwoPage() {
	return (
		<div className="pt-[1.625rem] sm:h-full sm:overflow-hidden sm:overflow-y-scroll sm:pt-[5.125rem]">
			<img src={TOP_BG} className="absolute -top-[4.5rem] right-0 z-[1] sm:top-0 sm:rounded-t-2xl" alt="" />
			<BG_BLACK className="absolute -top-[4.5rem] left-0 z-[2] h-auto w-full sm:top-0 sm:rounded-t-2xl" />
			<div className="relative z-10">
				<img src={TIPS_BG} className="absolute left-0 top-[263px] z-0" alt="" />
				<HomeSwap />
				<HomeTips />
				<HomeAdd />
				<HomeTrade />
				<HomeHelp />
				<Footer />
			</div>
		</div>
	)
}
